import { ApiService } from 'js/src/client';
import { Toast } from 'js/src/components/common/Toast';
import { setBrandKitsLoading, storeBrandKits } from 'js/src/data/brand-kits';
import { ImmutableFromJS } from 'js/src/libs/consts';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

export function loadBrandKits() {
    return (dispatch: AppDispatch) => {
        dispatch(setBrandKitsLoading({ flag: true }));
        ApiService.brandKitsList()
            .then((response) => {
                const orderedBrandKitList = response.data.sort(
                    (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() && 1) || -1,
                );
                const immutableBrandKits = ImmutableFromJS(orderedBrandKitList);
                dispatch(storeBrandKits({ brandKits: immutableBrandKits }));
            })
            .catch((e: unknown) => {
                ErrorReporter.capture(e);
                Toast.error(
                    'Something went wrong with loading your brand kits, try refreshing the page.',
                );
            })
            .finally(() => {
                dispatch(setBrandKitsLoading({ flag: false }));
            });
    };
}
